
function slider() {
	jQuery('.js-slider').slick({
		dots: true,
		arrows: true,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 7000
	});
	jQuery('.js-product').slick({
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 4,
		slidesToScroll: 4,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			},
			{
				breakpoint: 768,
				settings: {
					variableWidth: true,
					arrows: true,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
	jQuery('.js-review').slick({
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 2,
		slidesToScroll: 2,
		arrows: true,
		prevArrow: '.arrow--prev',
		nextArrow: '.arrow--next',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					variableWidth: true
				}
			}
		]
	});

	$('.product-slider-for').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		asNavFor: '.product-slider-nav'
	});
	$('.product-slider-nav').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		asNavFor: '.product-slider-for',
		focusOnSelect: true,
		arrows: false,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					vertical: false,
					slidesToShow: 4,
					slidesToScroll: 1,
				},
			}
		],
	});
	jQuery('.js-cart-slider').slick({
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 4,
		slidesToScroll: 4,
		arrows: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			}
		]
	});
	jQuery('.js-seller').slick({
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 4,
		slidesToScroll: 4,
		arrows: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
}
$('.input-group-btn--down').on('click', function (e) {
	let $input = $(this).prev('input');

	let val = parseInt($input.val());
	$input.val(val + 1).change();
});

$('.input-group-btn--up').on('click', function (e) {
	let $input = $(this).next('input');
	var val = parseInt($input.val());
	if (val > 0) {
		$input.val(val - 1).change();
	}
});
$('.bndlr-volume-saving-text').on('click', function (e) {
	var product_id = $(this).parent().attr('data-product');
	var quantity = $(this).parent().attr('data-quantity');
	$.post(window.Shopify.routes.root + 'cart/add.js',{
		items: [
			{
			 id: product_id,
			 quantity: quantity
			}
		]
	}, function(data) {
		 return data;
	},"json")
	.done(function(data) {
		console.log(data)
		window.location.href = window.location.origin + "/checkout"
	})
	.fail(function(response) {
		alert(response.responseJSON.description)
	})
});
function anker() {
	$('.js-anker[href^="#"]').click(function () {
		let href = $(this).attr('href');
		let target = $(href == "#" || href == "" ? 'html' : href);
		let position = target.offset().top - 85;
		$('html, body').animate({
			scrollTop: position
		}, 500);
		return false;
	});
}
function showform() {

	$('.js-show-item').click(function (e) {
		e.preventDefault();
		$(this).next().toggleClass('is-active');
	});
}

function showtab() {
	$('.js-tab').click(function (e) {
		e.preventDefault();
		var el = $(this).attr('data-id');
		console.log(el)
		$('.js-tab').removeClass('is-active');
		$('.js-content-tab').removeClass('is-active');

		$(this).addClass('is-active');
		$("#" + el).addClass('is-active');
	});
}
function sliderins() {
	jQuery('.js-slider-ins').slick({
		dots: false,
		infinite: true,
		speed: 300,
		variableWidth: true
	});
}
//init
//---------------------------------------------------------
$(function () {
	slider();
	anker();
	showform();
	showtab();
	sliderins();
});
